import Vue from "vue";
import Router from "vue-router";
import Login from "../views/auth/Login.vue";
import Register from "../views/auth/Register.vue";
import Faq from "../views/Faq.vue";
import VueAnalytics from "vue-ua";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import NewPassword from "@/views/auth/NewPassword.vue";
import Store from "@/store";
import {allAreWelcome, logOutRoutesOnly} from "@/Variables";
import GenexUtils from "@/utils/GenexUtils";


Vue.use(Router);

const index = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            meta: {
                numId: 1,
            },
        },
        {
            path: "/notes/course-modules",
            name: "/notes/course-modules",
            component: () => import("@/views/lessonNotes"),
            meta: {
                title: "Notes",
                highlight: "notes",
                numId: 2,
            },
            children: [
                {
                    path: "/notes/course-modules/:courseModuleId/lesson-notes",
                    name: "/notes/course-modules/:courseModuleId/lesson-notes",
                    component: () => import("@/views/lessonNotes"),
                    meta: {
                        title: "Notes",
                        highlight: "notes",
                        numId: 3,
                    },
                },
                {
                    path: "/notes/course-modules/:courseModuleId/lesson-notes/:lessonId",
                    name: "/notes/course-modules/:courseModuleId/lesson-notes/:lessonId",
                    component: () => import("@/views/lessonNotes"),
                    meta: {
                        title: "Notes",
                        highlight: "notes",
                        numId: 4,
                    },
                },
            ],
        },
        {
            path: "/workspace",
            name: "/workspace",
            component: () => import("@/views/Workspace.vue"),
            meta: {
                title: "Workspace",
                highlight: "/workspace",
                breadcrumb_name: "Workspace",
                breadcrumbs_ancestry: ["/lesson-plans/subjects"],
                numId: 5,
            },
            redirect: "/workspace/tasks",
            children: [
                {
                    path: "/workspace/tasks",
                    name: "tasks",
                    component: () => import("@/views/workspace/TaskIndex.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: "Tasks",
                        breadcrumbs_ancestry: ["/workspace"],
                        numId: 6,
                    },
                },
                {
                    path: "/workspace/tasks/classes",
                    meta: {
                        breadcrumb_name: "Classes",
                        breadcrumbs_ancestry: ["/workspace"],
                        numId: 7,
                    },
                    redirect: "/workspace/tasks",
                },
                {
                    path: "/workspace/tasks/:subjectId/:subjectName",
                    name: "TasksView",
                    props: true,
                    redirect: route => {
                        return {
                            name: "/workspace/tasks/:subjectId/:subjectName/submissions",
                            params: {
                                subjectName: route.params.subjectName,
                                subjectId: route.params.subjectId,
                            },
                        };
                    },
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: ":subjectName",
                        breadcrumbs_ancestry: ["/workspace", "/workspace/tasks", "/workspace/tasks/classes"],
                        numId: 8,
                    },
                },
                {
                    path: "/workspace/tasks/:subjectId/:subjectName/submissions",
                    name: "/workspace/tasks/:subjectId/:subjectName/submissions",
                    props: true,
                    component: () => import("@/views/workspace/SubjectTaskView.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: "Submissions",
                        breadcrumbs_ancestry: [
                            "/workspace",
                            "/workspace/tasks",
                            "/workspace/tasks/classes",
                            "/workspace/tasks/:subjectId/:subjectName",
                        ],
                        numId: 9,
                    },
                },
                {
                    path: "/workspace/tasks/:subjectId/:subjectName/:id/:name",
                    name: "TaskSubmission",
                    component: () => import("@/views/workspace/TaskSubmission.vue"),
                    props: true,
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: ":name",
                        breadcrumbs_ancestry: [
                            "/workspace",
                            "/workspace/tasks",
                            "/workspace/tasks/classes",
                            "/workspace/tasks/:subjectId/:subjectName",
                            "/workspace/tasks/:subjectId/:subjectName/submissions",
                        ],
                        numId: 10,
                    },
                },
                {
                    path: "/workspace/journals",
                    name: "tasks",
                    component: () => import("@/views/workspace/JournalIndex.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: "Journals",
                        breadcrumbs_ancestry: ["/workspace"],
                        numId: 11,
                    },
                },
                {
                    path: "/workspace/journals/:subjectId/:subjectName",
                    name: "JournalsView",
                    props: true,
                    component: () => import("@/views/workspace/SubjectJournalView.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: ":subjectName",
                        breadcrumbs_ancestry: ["/workspace", "/workspace/journals"],
                        numId: 12,
                    },
                },
                {
                    path: "/workspace/journals/:subjectId/:subjectName/submissions",
                    name: "/workspace/journals/:subjectId/:subjectName/submissions",
                    props: true,
                    component: () => import("@/views/workspace/SubjectJournalView.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: "Entries",
                        breadcrumbs_ancestry: ["/workspace", "/workspace/journals", "/workspace/journals/:subjectId/:subjectName"],
                        numId: 13,
                    },
                },
                {
                    path: "/workspace/journals/:subjectId/:subjectName/new",
                    name: "JournalsNew",
                    props: true,
                    component: () => import("@/views/workspace/JournalForm.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: "Create",
                        breadcrumbs_ancestry: [
                            "/workspace",
                            "/workspace/journals",
                            "/workspace/journals/:subjectId/:subjectName",
                            "/workspace/journals/:subjectId/:subjectName/submissions",
                        ],
                        numId: 14,
                    },
                },
                {
                    path: "/workspace/journals/:subjectId/:subjectName/:id/:name",
                    name: "JournalsEdit",
                    component: () => import("@/views/workspace/JournalForm.vue"),
                    props: true,
                    meta: {
                        title: "Workspace",
                        highlight: "/tasks",
                        breadcrumb_name: ":name",
                        breadcrumbs_ancestry: [
                            "/workspace",
                            "/workspace/journals",
                            "/workspace/journals/:subjectId/:subjectName",
                            "/workspace/journals/:subjectId/:subjectName/submissions",
                        ],
                        numId: 15,
                    },
                },
                {
                    path: "/workspace/resources",
                    name: "/workspace/resources",
                    component: () => import("@/views/Workspace.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/workspace",
                        breadcrumb_name: "Resources",
                        breadcrumbs_ancestry: ["/workspace"],
                        numId: 16,
                    },
                    redirect: "/workspace/resources/classes",
                    children: [],
                },
                {
                    path: "/workspace/resources/classes",
                    name: "/workspace/resources/classes",
                    component: () => import("@/views/Workspace.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/workspace",
                        breadcrumb_name: "Classes",
                        breadcrumbs_ancestry: ["/workspace", "/workspace/resources"],
                        numId: 17,
                    },
                    children: [],
                },
                {
                    path: "/workspace/resources/classes/:cId/:cName",
                    name: "/workspace/resources/classes/:cId/:cName",
                    component: () => import("@/views/Workspace.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/workspace",
                        breadcrumb_name: ":cName",
                        breadcrumbs_ancestry: ["/workspace", "/workspace/resources", "/workspace/resources/classes"],
                        numId: 18,
                    },
                    redirect: route => {
                        return {
                            name: "/workspace/resources/classes/:cId/:cName/resources/:rPath",
                            params: {
                                cId: route.params.cId,
                                cName: route.params.cName,
                                rPath: route.params.cId,
                            },
                        };
                    },
                    children: [],
                },
                {
                    path: "/workspace/resources/classes/:cId/:cName/resources",
                    name: "/workspace/resources/classes/:cId/:cName/resources",
                    component: () => import("@/views/Workspace.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/workspace",
                        breadcrumb_name: "Resources",
                        breadcrumbs_ancestry: [
                            "/workspace",
                            "/workspace/resources",
                            "/workspace/resources/classes",
                            "/workspace/resources/classes/:cId/:cName",
                        ],
                        numId: 19,
                    },
                    children: [],
                },
                {
                    path: "/workspace/resources/classes/:cId/:cName/resources/:rPath",
                    name: "/workspace/resources/classes/:cId/:cName/resources/:rPath",
                    component: () => import("@/views/Workspace.vue"),
                    meta: {
                        title: "Workspace",
                        highlight: "/workspace",
                        breadcrumb_name: "Resources",
                        breadcrumbs_ancestry: [
                            "/workspace",
                            "/workspace/resources",
                            "/workspace/resources/classes",
                            "/workspace/resources/classes/:cId/:cName",
                        ],
                        numId: 20,
                    },
                    children: [],
                },
            ],
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: () => import("@/views/dashboard/Dashboard.vue"),
            meta: {
                title: "Dashboard",
                highlight: "dashboard",
                numId: 21,
            },
        },
        {
            path: "/courses",
            name: "courses",
            component: () => import("@/views/courses/Index.vue"),
            meta: {
                title: "Courses",
                highlight: "courses",
                numId: 22,
            },
        },
        {
            path: "/courses/:courseId",
            name: "courses.view",
            component: () => import("@/views/courses/View.vue"),
            props: true,
            meta: {
                title: "Courses",
                highlight: "courses",
                numId: 23,
            },
        },
        {
            path: "/courses/:courseId/modules/:moduleId/lessons/:lessonId",
            name: "courses.module.lesson",
            component: () => import("@/views/modules/ModuleView.vue"),
            props: route => ({
                courseId: route.params.courseId,
                moduleId: route.params.moduleId,
                lessonId: route.params.lessonId,
                isLesson: true,
            }),
            meta: {
                numId: 24,
            },
        },
        {
            path: "/courses/:courseId/module-entities/:moduleEntityId/modules/:moduleId/assessments/:assessmentId",
            name: "courses.module.assessment",
            component: () => import("@/views/modules/ModuleView.vue"),
            props: route => ({
                courseId: route.params.courseId,
                moduleId: route.params.moduleId,
                assessmentId: route.params.assessmentId,
                isAssessment: true,
            }),
            children: [
                {
                    path: "",
                    component: () => import("@/components/assessments/SubmissionView.vue"),
                    children: [
                        {
                            path: "",
                            name: "courses.module.assessment.submission.start",
                            component: () => import("@/components/assessments/StartView.vue"),
                            props: route => ({
                                courseId: route.params.courseId,
                                moduleId: route.params.moduleId,
                                assessmentId: route.params.assessmentId,
                                isAssessment: true,
                            }),
                            meta: {
                                numId: 27,
                            },
                        },
                        {
                            path: "submissions",
                            name: "courses.module.assessment.submissions",
                            component: () => import("@/components/assessments/Submissions.vue"),
                            props: route => ({
                                courseId: route.params.courseId,
                                moduleId: route.params.moduleId,
                                assessmentId: route.params.assessmentId,
                                isAssessment: true,
                            }),
                            meta: {
                                numId: 28,
                            },
                        },
                        {
                            path: "submissions/:userAssessmentId",
                            name: "courses.module.assessment.submissions.review",
                            component: () => import("@/components/assessments/AssessmentDisplay.vue"),
                            props: route => ({
                                courseId: route.params.courseId,
                                moduleId: route.params.moduleId,
                                assessmentId: route.params.assessmentId,
                                userAssessmentId: route.params.userAssessmentId,
                                isAssessment: true,
                                isReviewMode: true,
                            }),
                            meta: {
                                numId: 29,
                            },
                        },
                        {
                            path: "submissions/:userAssessmentId/submit",
                            name: "courses.module.assessment.submission.display",
                            component: () => import("@/components/assessments/AssessmentDisplay.vue"),
                            props: route => ({
                                courseId: route.params.courseId,
                                moduleId: route.params.moduleId,
                                assessmentId: route.params.assessmentId,
                                userAssessmentId: route.params.userAssessmentId,
                                isAssessment: true,
                            }),
                            meta: {
                                numId: 30,
                            },
                        },
                    ],
                    meta: {
                        numId: 26,
                    },
                },
            ],
            meta: {
                numId: 25,
            },
        },
        {
            name: "forum.index",
            path: "/forum/",
            props: true,
            component: () => import("@/views/forum/Index"),
            meta: {
                title: 'Forum',
                numId: 31,
            },
        },
        {
            path: "/faq",
            name: "faq",
            component: Faq,
            meta: {
                title: "FAQ",
                numId: 32,
            },
        },
        {
            path: "/login",
            name: "auth.login",
            component: Login,
            meta: {
                title: "Login",
                numId: 33,
            },
        },
        {
            path: "/login/:tenant",
            name: "auth.login.tenant",
            component: Login,
            props: true,
            meta: {
                title: "Login",
                numId: 34,
            },
        },
        {
            path: "/external-login",
            name: "auth.external-login",
            component: () => import("@/views/auth/externalLogin.vue"),
            meta: {
                title: "Login",
                numId: 35,
            },
        },
        {
            path: "/forgot-password",
            name: "auth.forgot-password",
            component: ForgotPassword,
            meta: {
                title: "Forgot Password",
                numId: 36,
            },
        },
        {
            path: "/password-reset/:token",
            props: true,
            name: "auth.new-password",
            component: NewPassword,
            meta: {
                title: "New Password",
                numId: 37,
            },
            beforeEnter: (to, from, next) => {
                if (to.params.token) {
                    next(); // <-- everything good, proceed
                } else {
                    next({name: "auth.login"}); // <-- redirect to login
                }
            },
        },
        {
            path: "/register",
            name: "auth.register",
            component: Register,
            meta: {
                title: "Register",
                numId: 38,
            },
        },
        {
            path: "/e-studio",
            name: "e-studio",
            component: () => import("../views/E-Studio.vue"),
            props: true,
            meta: {
                title: "E-Studio",
                numId: 39,
            },
        },
        {
            path: "/e-studio/:documentId",
            name: "e-studio.document",
            component: () => import("../views/E-Studio.vue"),
            props: true,
            meta: {
                title: "E-Studio",
                numId: 40,
            },
        },
        {
            path: "/e-studio/project/:projectId",
            name: "e-studio.project",
            component: () => import("../views/E-Studio.vue"),
            props: true,
            meta: {
                title: "E-Studio",
                numId: 41,
            },
        },
        {
            path: "/profiles",
            name: "profiles.index",
            meta: {
                title: "Profile",
                numId: 42,
            },
            component: () => import("../views/profile/Index.vue"),
        },
        {
            path: "/profiles/:userId",
            name: "profiles.view",
            props: true,
            meta: {
                title: "Profile",
                numId: 43,
            },
            component: () => import("../views/profile/View.vue"),
        },
        {
            path: "/students",
            name: "students",
            component: () => import("../views/Students.vue"),
            meta: {
                numId: 44,
            },
        },
        {
            path: "/students/projectreview/:studentName/:documentId",
            name: "students.projectreview",
            component: () => import("../components/students/ProjectReview.vue"),
            props: true,
            meta: {
                numId: 45,
            },
        },
        {
            path: "/projects",
            name: "projects",
            component: () => import("../views/Projects.vue"),
            meta: {
                title: "Projects",
                numId: 46,
            },
        },
        {
            path: "/projects/:groupId/:userId/:projectId",
            name: "projects.project",
            component: () => import("../components/projects/Project.vue"),
            props: true,
            meta: {
                title: "Projects",
                numId: 47,
            },
        },
        {
            path: "/my-journal",
            name: "my-journal",
            component: () => import("../views/Journal.vue"),
            meta: {
                title: "Journal",
                numId: 48,
            },
        },
        {
            path: "/my-resources",
            name: "my-resources",
            meta: {
                title: "Resources",
                numId: 49,
            },
            component: () => import("../views/Resources.vue"),
        },
        {
            path: "/support",
            name: "support",
            meta: {
                title: "Support",
                numId: 50,
            },
            component: () => import("../views/Support.vue"),
        },
        {
            path: "/book",
            name: "book",
            meta: {
                title: "Book",
                numId: 51,
            },
            component: () => import("../views/Book.vue"),
        },
        {
            path: "/lessons",
            name: "lessons",
            component: () => import("@/views/lessons/Index.vue"),
            meta: {
                title: "Lessons",
                highlight: "lessons",
                breadcrumb_name: "lessons",
                numId: 52,
            },
        },
        {
            path: "/lessons/:lessonId",
            name: "lessons.view",
            component: () => import("@/views/lessons/View.vue"),
            props: true,
            meta: {
                title: "Lessons",
                highlight: "lessons",
                breadcrumb_name: "lesson",
                breadcrumbs_ancestry: [
                    "/lessons",
                    "/:lessonId",
                ],
                numId: 53,
            },
        },
        {
            path: "/forgot-password/:tenant",
            name: "auth.forgot-password",
            component: ForgotPassword,
            meta: {
                title: "GenEx | Forgot Password",
                numId: 54,
            },
        },
    ],
});

Vue.use(VueAnalytics, {
    // [Required] The name of your app as specified in Google Analytics.
    appName: "DigiWorld",
    // [Required] The version of your app.
    appVersion: "1.0",
    // [Required] Your Google Analytics tracking ID.
    trackingId: "UA-81194973-7",
    // If you're using vue-index, pass the index instance here.
    vueRouter: index,

    // Global Dimensions and Metrics can optionally be specified.
});

index.beforeEach(async (to, from, next) => {
    const {state} = Store;

    if (allAreWelcome.includes(to.name)) {
        return next();
    }
    if (!state.auth.user) {
        if (logOutRoutesOnly.includes(to.name) || allAreWelcome.includes(to.name)) {
            await Store.dispatch("url/setPrevious", to.fullPath);
            await Store.dispatch("loader/hide");
            return next();
        } else {


            try {
                await GenexUtils.getAuthDetailsAndSaveThem().then(() => {
                    Store.dispatch("url/setPrevious", to.fullPath);
                    Store.dispatch("loader/hide");
                    return next();
                })
            } catch (e) {
                const {state} = Store;

                state.requestedHandshake = true;
                await Store.dispatch("toast/createToast", {
                    message: "Please login to continue",
                });
                await Store.dispatch("auth/delete");
                await Store.dispatch("tenant/logout");
                await index.push({name: "auth.login"});
                await Store.dispatch("loader/hide");
            }
        }
    } else {

        // check popia act agreement
        if (!state.auth?.user?.accepted_popia_at) {
            await Store.dispatch("auth/delete");
            await Store.dispatch("tenant/logout");
            if (to.fullPath.includes("login")) {
                await Store.dispatch("loader/hide");
                return next();
            } else {
                await Store.dispatch("loader/hide");
                window.location.href = "/login";
            }
        } 

        if (logOutRoutesOnly.includes(to.name)) {
            await Store.dispatch("loader/hide");
            return await index.push(state.url.previous);
        } else {
            return next();
        }
    }
});

export default index;
